module.exports = "/images/e8a7865ab5af8bdc72d7c5c9ef00ff29.svg";